import usePrice from '@commerce/product/use-price'
import { useTranslation } from 'next-i18next'
interface props {
  name: string | undefined
  price: number
  listPrice?: number
  currencyCode: string
  multiplePrice?: boolean
  selected?: boolean
  isB2bCustomer: boolean
  isB2bProduct: boolean
  onClick?: () => void
}

export default function SampleProductOptionLabel({
  name,
  price,
  listPrice,
  currencyCode,
  multiplePrice = true,
  selected,
  isB2bCustomer = false,
  isB2bProduct = false,
  onClick,
}: props) {
  const { t } = useTranslation('common')

  const priceLocale = usePrice({
    amount: price,
    currencyCode: currencyCode,
  })
  const listPriceLocale = usePrice({
    amount: listPrice,
    currencyCode: currencyCode,
  })

  if (isB2bProduct && !isB2bCustomer) return null

  return (
    <button
      className={`flex w-full cursor-pointer flex-col items-center justify-between gap-y-2 rounded-sm border bg-white py-4 text-ui-dark-grey ${
        selected ? 'border-ui-dark-grey bg-ui-light-grey' : 'border-ui-grey-25'
      }`}
      onClick={onClick}
    >
      <div className="body-1-bold">
        {t(`${name?.replaceAll(' ', '-').toLowerCase()}`)}
      </div>
      <div className="body-2">
        {multiplePrice && ` ${t('from')} `}
        {listPrice && listPrice > price ? (
          <del className="mr-1">{listPriceLocale.price}</del>
        ) : null}
        <span>{priceLocale.price}</span>
      </div>
    </button>
  )
}
